import { render } from "./TeamingButton.vue?vue&type=template&id=566427ef&scoped=true"
import script from "./TeamingButton.vue?vue&type=script&lang=js"
export * from "./TeamingButton.vue?vue&type=script&lang=js"

import "./TeamingButton.vue?vue&type=style&index=0&id=566427ef&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-566427ef"

export default script